/********************************************************
* MODAL CONTROL MODULE
*
* description text
*
********************************************************/


/**********************************************
 DEPENDENCIES
**********************************************/

var $ = require('jquery');
var Ractive = require('ractive');

var template = require('Templates/modal.html');


/**********************************************
 VARIABLE DECLARATION
**********************************************/

var self = {};
var view;


/**********************************************
 HELPER FUNCTIONS
**********************************************/



/**********************************************
 PRIVATE FUNCTIONS
**********************************************/

var template_init = function() {
	setTimeout( function() {
		$('#modal_container').addClass('modal_container--show');
	}, 10);

	$("#modal_cancel").off().on('click', function(e) {
		e.preventDefault();
		kill_modal();
	});

	$("#modal_action").off().on('click', function(e) {
		e.preventDefault();

		if (view.get('input')) {

			if ( view.get('input_value').length == 0 ) {
				//console.log('error');
				view.set('error', true);
			}
			else {
				view.set('error', false);
				view.get('callback')( view.get('input_value') );
				kill_modal();
			}
		}
		else {
			view.get('callback')();
			kill_modal();
		}
	});

	if (view.get('input')) {
		$('#modal_container input').focus();
	}

}


var kill_modal = function() {
	$('#modal_container').removeClass('modal_container--show');
	view = null;
	$('#modal_container').html('');
}


var create_modal = function(data) {
	// load modal
	view = new Ractive({
		el : '#modal_container',
		template : template,
		oncomplete : template_init,
		data : data
	});
}

/**********************************************
 PUBLIC FUNCTIONS
**********************************************/


self.alert = function(title, message) {

	var data = {
		title : title,
		message : message,
		cancel_btn : "Dismiss"
	}

	create_modal(data);
}


self.ask = function(title, message, cb) {

	var data = {
		title : title,
		message : message,
		input : true,
		cancel_btn : "Cancel",
		action_btn : "Submit",
		callback : cb
	}

	create_modal(data);
}


self.confirmation = function(title, message, action_btn, cb) {

	var data = {
		title : title,
		message : message,
		cancel_btn : "Cancel",
		action_btn : action_btn,
		callback : cb
	}

	create_modal(data);
}

/**********************************************
 MODULE EXPORT
**********************************************/
module.exports = self;